import options2Map from '@/utils/options2Map'

export const tableKey = {
  skuId: 'skuDetails.skuId',
  warehouseExpressId: 'logistics.warehouseExpressId',
  consigneeInfo: 'consigneeInfo',
  mainStatus: 'mainStatus',
  failReason: 'failReason',
  createTime: 'createTime',
  operation: 'operation',
  outboundTime: 'outboundTime',
  _serialNumber: '_serialNumber',
  requiredDeliveryDates: 'requiredDeliveryDates',
  hangDownTime: 'hangDownTime',
  orderSource: 'source',
  salesPlatform: 'salesPlatform',
  storeName: 'storeName',
  shipmentTime: 'shipmentTime',
  cancelTime: 'cancelTime',
  warehouseName: 'warehouseName',
  logisticsProviderNames: 'logisticsProviderNames',
  pushTime: 'pushTime',
  platformCreateTime: 'platformCreateTime',
  orderMcId: 'orderMcId',
}

export enum SEARCH_TYPE {
  ORDER_MC_ID = 'orderMcId',
  ORDER_SHORT_ID = 'orderShortId',
  LOGISTICS_EXPRESS_ID = 'logisticsExpressId',
  HANGDOWN_DATE = 'hangDownDate',
  EXPECTED_ARRIVAL_DATE = 'expectedArrivalDate',
  SKU_ID = 'skuId',
  RECIPIENT = 'recipient',
  SKU_NAME = 'skuName',
  CREATE_DATE = 'createDate',
  PLATFORM_CREATE = 'platformCreate',
  VOID_DATE = 'voidDate',
  SHIP_DATE = 'shipDate',
  OUNTBOUND_DATE = 'ountboundDate',
  OUTBOUND_ORDER_SKUID = 'outboundOrderSkuId',
  OUTBOUND_SHORT_ID = 'outboundShortId',
  PUSH_WAREHOUSE_DATE = 'pushTime',
  IMEI = 'imei',
}

export enum HANGUP_TAGS {
  /** 待处理 */
  TAGONEWAREHOUSE_01 = 'TAGONEWAREHOUSE_01',
  /** 异常 */
  TAGONEWAREHOUSE_02 = 'TAGONEWAREHOUSE_02',
  /** 挂起 */
  TAGONEWAREHOUSE_03 = 'TAGONEWAREHOUSE_03',
  /** 预售 */
  TAGONEWAREHOUSE_04 = 'TAGONEWAREHOUSE_04',
  /** 母单 */
  TAGONEWAREHOUSE_05 = 'TAGONEWAREHOUSE_05',
  /** 子单 */
  TAGONEWAREHOUSE_06 = 'TAGONEWAREHOUSE_06',
  /** 门店关转 */
  TAGONEWAREHOUSE_12 = 'TAGONEWAREHOUSE_12',
  /** 退货 */
  TAG_ORDER_ONEWAREHOUSE_15 = 'TAG_ORDER_ONEWAREHOUSE_15',
  /** 复制订单 */
  TAG_ORDER_ONEWAREHOUSE_16 = 'TAG_ORDER_ONEWAREHOUSE_16',
  /** 已合单 */
  TAG_ORDER_OW_MERGED_17 = 'TAG_ORDER_OW_MERGED_17',
  /** 可智能合并 */
  TAG_ORDER_OW_CAN_AUTO_MERGE_18 = 'TAG_ORDER_OW_CAN_AUTO_MERGE_18',
  /** 赠品 */
  TAG_ORDER_OW_GIFT_19 = 'TAG_ORDER_OW_GIFT_19',
  /** 多包裹 */
  MULTIPLE_PACKAGES_TAG_20 = 'MULTIPLE_PACKAGES_TAG_20',
}

/** 需要直接展示下游的错误信息的 https://shopline.atlassian.net/browse/BGFH-1553 */
export const NEED_SHOW_ERROR_MESSAGE = [
  'provider_error',
  'logistics_no_or_waybill_error',
  'provider_outbound_fail',
  'platform_order_not_shipped',
  'platform_order_cancelled',
  'unknown_logistics',
  'warehouse_shipment_error',
  'intercepted',
]

/**msg等于REMOTE_ERROR直接显示请求超时或网络异常导致，请稍后重试 */
export const SHOW_RETRY_MESSAGE = 'REMOTE_ERROR'

export const ERROR_MSG_2_I18N_KEY: Record<string, string> = {
  [SHOW_RETRY_MESSAGE]: 'common.retry.request',
}

// 订单状态映射
export enum ORDER_STATUS_MAP {
  /**全部 */
  ALL = 'all',
  /**待处理 */
  PENDING = 'pending',
  /**待出库 */
  TO_OUTBOUND = 'to_outbound',
  /**已出库 */
  COMPLETED = 'completed',
  /**已作废 */
  CANCELLED = 'cancelled',
  /**门店关转 */
  CLOSED = 'closed',
}

// 仓库状态映射
export enum WAREHOUSE_STATUS_MAP {
  /** 使用中 */
  ENABLE = 'enable',
  /** 已停用 */
  DISABLE = 'disable',
}

export const DELIVER_TYPE = [
  {
    value: 'home',
    label: 'enums.outboundDeliveryType.home',
  },
  {
    value: 'store',
    label: 'enums.outboundDeliveryType.store',
  },
]

/** 编辑表头中的表头多语言 */
export const fieldDescription = {
  numberIndexCol: 'table.sort.number',
  orderMcIdCol: 'order.pageCreate.field.orderMc',
  orderNoCol: 'common.order',
  orderTypesCol: 'order.common.orderType',
  consigneeInfoCol: 'order.index.consigneeInfo',
  logisticChannelCol: 'common.logisticChannel',
  warehouseCol: 'user.center.storehouse',
  logisticsProviderNamesCol: 'order.logisticsProviderNames',
  mainStatusCol: 'common.status',
  logisticStatusCol: 'order.status.logisticStatus',
  storeClosedCol: 'order.storeClosed',
  createTimeCol: 'common.createTime',
  orderSourceCol: 'order.index.orderSource',
  salesPlatformCol: 'order.index.salesPlatform',
  salesStoreCol: 'order.index.salesStore',
  shipTimeCol: 'order.index.shipTime',
  pushTimeCol: 'order.index.pushWarehouseTime',
  voidTimeCol: 'order.index.voidTime',
  operationCol: 'common.toperation',
  failReasonCol: 'order.index.failReason',
  hangDownTimeCol: 'order.index.hangUp.hangDownTime',
  requiredDeliveryDatesCol: 'order.index.hangUp.expectedArrivalDate',
  outboundTimeCol: 'order.index.outboundTime',
  extInfoCol: 'order.table.noticeInfo',
  outboundTypeCol: 'order.index.outboundType',
  allocatedStatusCol: 'order.allocated.type',
  autoShipmentTimeCol: 'order.bookShip.time',
  platformCreateTimeCol: 'warehousing.sort.platformCreateTime',
  customTagsCol: 'order.custom.tag',
  platformShipmentDeadlineCol: 'order.table.platformShipmentDeadline',
}

export const DateGroupTypes = new Map([
  [SEARCH_TYPE.HANGDOWN_DATE, 'order.index.hangUp.hangDownDate'],
  [SEARCH_TYPE.EXPECTED_ARRIVAL_DATE, 'order.index.hangUp.expectedArrivalDate'],
  [SEARCH_TYPE.CREATE_DATE, 'common.createTime'],
  [SEARCH_TYPE.SHIP_DATE, 'order.index.shipTime'],
  [SEARCH_TYPE.OUNTBOUND_DATE, 'order.index.ountboundTime'],
  [SEARCH_TYPE.VOID_DATE, 'order.index.voidTime'],
  [SEARCH_TYPE.PUSH_WAREHOUSE_DATE, 'order.index.pushWarehouseTime'],
  [SEARCH_TYPE.PLATFORM_CREATE, 'warehousing.sort.platformCreateTime'],
])

export const OutboundProductTagMap = new Map([
  ['TAGONEWAREHOUSE_07', 'order.tag.homoeothermy'],
  ['TAGONEWAREHOUSE_08', 'order.tag.ac'],
  ['TAGONEWAREHOUSE_09', 'order.tag.freeze'],
  ['TAGONEWAREHOUSE_10', 'order.create.withElectry'],
  ['TAGONEWAREHOUSE_11', 'order.tag.group'],
  ['TAGONEWAREHOUSE_13', 'order.tag.cold2'],
  ['PRODUCT_BLANK_TAG', 'order.tag.none'],
  ['TAGONEWAREHOUSE_14', 'goods.singleShip'],
])

export const BatchSearchTypeOptions = [
  {
    label: 'order.index.search.orderMcId',
    value: SEARCH_TYPE.ORDER_MC_ID,
  },
  {
    label: 'order.index.search.outboundOrderId',
    value: SEARCH_TYPE.ORDER_SHORT_ID,
  },
  {
    label: 'order.index.search.expressId',
    value: SEARCH_TYPE.LOGISTICS_EXPRESS_ID,
  },
  {
    label: 'common.skuCode',
    value: SEARCH_TYPE.OUTBOUND_ORDER_SKUID,
  },
  {
    label: 'order.index.consigneeInfo',
    value: SEARCH_TYPE.RECIPIENT,
  },
  {
    label: 'common.imei',
    value: SEARCH_TYPE.IMEI,
  },
]

export const SearchTypeOptions = [
  {
    label: 'order.index.search.orderMcId',
    value: SEARCH_TYPE.ORDER_MC_ID,
  },
  {
    label: 'order.index.search.outboundOrderId',
    value: SEARCH_TYPE.ORDER_SHORT_ID,
  },
  {
    label: 'order.index.search.expressId',
    value: SEARCH_TYPE.LOGISTICS_EXPRESS_ID,
  },
  {
    label: 'common.skuCode',
    value: SEARCH_TYPE.OUTBOUND_ORDER_SKUID,
  },
  {
    label: 'common.skuName',
    value: SEARCH_TYPE.SKU_NAME,
  },
  {
    label: 'order.index.consigneeInfo',
    value: SEARCH_TYPE.RECIPIENT,
  },
  {
    label: 'common.imei',
    value: SEARCH_TYPE.IMEI,
  },
]

export const SearchTypeOptionsMap = options2Map(SearchTypeOptions)

// 表单onChange时触发缓存tag的keys
export const ChangeCacheTagKeys = ['outboundOrderTag', 'outboundProductTag']

/** 错误类型 */
export const ERROR_TYPE = {
  /** 待处理 */
  pending: 'pending',
  /** 处理中 */
  processing: 'processing',
  /** 已处理 */
  completed: 'completed',
  /** 无需处理 */
  ignore: 'ignore',
  /** 已过期 */
  expired: 'expired',
}

export const ERROR_STATUS_LIST = [
  { value: ERROR_TYPE.pending, label: 'order.status.toBeProcessed', number: 0 },
  { value: ERROR_TYPE.processing, label: 'order.status.processing', number: 0 },
  { value: ERROR_TYPE.completed, label: 'order.status.processed', number: 0 },
  { value: ERROR_TYPE.ignore, label: 'order.status.noNeedHandle', number: 0 },
  { value: ERROR_TYPE.expired, label: 'order.status.expired', number: 0 },
]

export const ERROR_STATUS_LIST_MAP = options2Map(ERROR_STATUS_LIST)

export const SORT_MAP = {
  createTime: 'create_time',
  shipmentTime: 'shipment_time',
  outboundTime: 'outbound_time',
  cancelTime: 'cancel_time',
  requiredDeliveryDates: 'logistics.required_delivery_dates_format',
  platformCreateTime: 'platform_create_time',
}

export const SORT_ORDER_MAP = {
  descend: 'desc',
  ascend: 'asc',
}
// 自定义标签 筛选方式
export const CUSTOM_TAG_FILTER_TYPE = [
  {
    value: 'in',
    label: 'common.include',
  },
  {
    value: 'and',
    label: 'order.custom.tag.same',
  },
  {
    value: 'not_in',
    label: 'common.exclude',
  },
]

export const CUSTOM_TAG_FILTER_TYPE_MAP = options2Map(CUSTOM_TAG_FILTER_TYPE)

/** 不需要去重的失败原因 */
export const EXCLUDE_UNIT_FAILREASON = ['order_should_be_split']
